import React from "react";
import { Card, Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import BulkOrderListing from "./BulkOrderListing";
import { BULK_UPLOAD_MESSAGES } from "./Json/BulkUploadMessages";

const { page } = BULK_UPLOAD_MESSAGES;

const breadcrumbItems = [
  { title: page.breadcrumbRoot, link: "" },
  { title: page.breadcrumbCurrent, link: page.breadcrumbLink },
];

const BulkOrder = () => (
  <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <BreadCrumb items={breadcrumbItems} />
        <Card>
          <BulkOrderListing />
        </Card>
      </Container>
    </div>
  </React.Fragment>
);

export default BulkOrder;
